import * as z from "zod/v4";

export const aeoOverrideType = [
  "brand_alias",
  "competitor_alias",
  "exclude",
] as const;
export type AeoOverrideType = (typeof aeoOverrideType)[number];

const competitorOverride_ = z.object({
  id: z.bigint(),
  matchTerm: z.string(),
  overrideType: z.enum(aeoOverrideType),
  canonicalName: z.string().nullable(),
  createdBy: z.string(),
  createdAt: z.string(),
});
export const competitorOverride: z.ZodType<CompetitorOverride> =
  competitorOverride_;
export interface CompetitorOverride
  extends z.infer<typeof competitorOverride_> {}
